import React, {Component} from 'react';
import {Form, Control, Errors} from 'react-redux-form'
import _ from "lodash";
import {isRequired, required} from "../field_validations";

export default class StrategieEditForm extends Component{
	render(){
		const {objectives} = this.props;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="strategies.edit" onSubmit={(goals) => this._submitForm(goals)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre de la estrategia <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".name" id="name" rows={2} className="textarea" placeholder="Nombre de la Meta" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field">
							<div className="control">
								<label htmlFor="objective_id" className="label">Objetivo <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".objective_id" id="objective_id" errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Objetivo ---</option>
										{_.map(objectives.list, (option, key) => {
											return <option key={key} value={option.id}>{option.code+' '+((option.name.length>100) ? option.name.substring(0, 100)+'...' : option.name)}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".objective_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar un eje temático. '}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="code" className="label">Código <span className="small has-text-danger">*</span></label>
								<Control.text model=".code" id="code" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".code" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength2: 'Codigo no valido'}} />
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/proigualdad/estrategias')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="strategies.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values) {
		this.props.strategieEditSave(values);
	}

	_validateSave(){
		const {strategies} = this.props;
		let sc = _.find(strategies.permissions, (o) => {return o==='Create'});
		let su = _.find(strategies.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(strategies.edit) && strategies.edit.id){
			if(su){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(strategies.edit) && _.isEmpty(strategies.edit.id)){
			if(sc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/strategies/form.jsx